export const colors = {
  twine: '#C49A6C',
  silver: '#C4C4C4',
  gallery: '#eee',
};
